<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

if($( "body" ).hasClass( "template-product" ) && (!$("div").hasClass( "is-active" ) ))
{
  //alert("test");
   $( "#tab-description").addClass( "is-active" );
   $( ".tab-title:eq(0)").addClass( "is-open" );
}

// Removing link functionality from empty URLs

$("a[href='#']").css('cursor', 'default');
//$(".image-with-text.image-with-text--reverse .metafield-rich_text_field p>a[href='#']").on('click', function(event){
$("a[href='#']").on('click', function(event){
  event.preventDefault();
});

// Redirect to new page

$(".halo-article-content a").each(function(){
    //event.preventDefault();
    var url = $(this).attr("href");
    $(this).attr("onclick", "window.open('"+url+"','_blank');return false");
});

//console.log("test"+$(location).attr('href'));
var currurl = window.location.href;
var lastPart = currurl.split('/').pop(); // Gets last segment after last "/"
if(lastPart=='gift-card'){
  $('.easify-product-options').hide();
}